<template>
  <div style="text-align:center;">
    <table cellspacing="0" class="table-box">
      <tbody v-for="(items, index) in this.result" :key="index">
        <tr>
          <td :class="trTitle[index]">
            {{ items.name }}

            <!-- {{ items.score }} -->
          </td>
          <td class="trContent">
            <div style="margin-left:20px;margin-top:20px;">
              定义：{{ items.define }}
            </div>
            <!-- 我努力过了，实在找不到合适的组件 -->
            <img
              :src="images.bar1"
              style="height: auto;width:9%;margin-left:20px;margin-top:10px"
            />

            <img
              v-if="items.score < 1 || items.score == 1"
              :src="images.bar2"
              style="height: auto;width:9%;margin-left:-3px"
            />

            <img
              v-if="items.score > 1 || items.score == 2"
              :src="images.bar22"
              style="height: auto;width:9%;margin-left:-3px"
            />

            <img
              v-if="items.score < 2 || items.score == 2"
              :src="images.bar3"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 2 || items.score == 3"
              :src="images.bar33"
              style="height: auto;width:9%;margin-left:-3px"
            />

            <img
              v-if="items.score < 3 || items.score == 3"
              :src="images.bar4"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 3 || items.score == 4"
              :src="images.bar44"
              style="height: auto;width:9%;margin-left:-3px"
            />

            <img
              v-if="items.score < 4 || items.score == 4"
              :src="images.bar5"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 4 || items.score == 5"
              :src="images.bar55"
              style="height: auto;width:9%;margin-left:-3px"
            />

            <img
              v-if="items.score < 5 || items.score == 5"
              :src="images.bar6"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 5 || items.score == 6"
              :src="images.bar66"
              style="height: auto;width:9%;margin-left:-3px"
            />

            <img
              v-if="items.score < 6 || items.score == 6"
              :src="images.bar7"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 6 || items.score == 7"
              :src="images.bar77"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score < 7 || items.score == 7"
              :src="images.bar8"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 7 || items.score == 8"
              :src="images.bar88"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score < 8 || items.score == 8"
              :src="images.bar9"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 8 || items.score == 9"
              :src="images.bar99"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score < 9 || items.score == 9"
              :src="images.bar10"
              style="height: auto;width:9%;margin-left:-3px"
            />
            <img
              v-if="items.score > 9 || items.score == 10"
              :src="images.bar100"
              style="height: auto;width:9%;margin-left:-3px"
            />

            <div style="margin:10px 20px 10px 20px;white-space:pre;">
              <span style="line-height:18px">{{ items.describe }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["model", "result", "score"],
  data() {
    return {
      trTitle: ["ss1", "ss2", "ss3", "ss4", "ss5", "ss6"],
      images: {
        bar1: require("../../../../assets/images/page6/progressBar/1.png"),
        bar2: require("../../../../assets/images/page6/progressBar/22.png"),
        bar3: require("../../../../assets/images/page6/progressBar/33.png"),
        bar4: require("../../../../assets/images/page6/progressBar/44.png"),
        bar5: require("../../../../assets/images/page6/progressBar/55.png"),
        bar6: require("../../../../assets/images/page6/progressBar/66.png"),
        bar7: require("../../../../assets/images/page6/progressBar/77.png"),
        bar8: require("../../../../assets/images/page6/progressBar/88.png"),
        bar9: require("../../../../assets/images/page6/progressBar/99.png"),
        bar10: require("../../../../assets/images/page6/progressBar/100.png"),
        bar11: require("../../../../assets/images/page6/progressBar/1.png"),
        bar22: require("../../../../assets/images/page6/progressBar/2.png"),
        bar33: require("../../../../assets/images/page6/progressBar/3.png"),
        bar44: require("../../../../assets/images/page6/progressBar/4.png"),
        bar55: require("../../../../assets/images/page6/progressBar/5.png"),
        bar66: require("../../../../assets/images/page6/progressBar/6.png"),
        bar77: require("../../../../assets/images/page6/progressBar/7.png"),
        bar88: require("../../../../assets/images/page6/progressBar/8.png"),
        bar99: require("../../../../assets/images/page6/progressBar/9.png"),
        bar100: require("../../../../assets/images/page6/progressBar/10.png")
      }
    };
  },
  methods: {}
};
</script>

<style scoped>
.table-box {
  text-align: justify;
  font-size: 10pt;
  width: 90%;
  margin-left: 40px;
  margin-right: 40px;
  border-collapse: separate;
  border-spacing: 4px;
}
.trTitle {
  height: auto;
  width: 100px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
}
.trContent {
  background-color: #f2f4f7;
}
.ss1 {
  height: 100px;
  width: 100px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background: #68c4ef;
}
.ss2 {
  height: 100px;
  width: 100px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background: #eb766e;
}
.ss3 {
  height: 100px;
  width: 100px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background: #f5b252;
}
.ss4 {
  height: 100px;
  width: 100px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background: #a3d36b;
}
.ss5 {
  height: 100px;
  width: 100px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background: #8982e8;
}
.ss6 {
  height: 100px;
  width: 100px;
  text-align: center;
  color: white;
  font-size: 15px;
  font-weight: bold;
  background: #8599a3;
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/table/three/characteristics.vue